export default function ClockCircleIcon() {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 2.0625C8.27393 2.0625 7.57492 2.17385 6.91855 2.38C6.62217 2.47309 6.30644 2.30829 6.21335 2.0119C6.12026 1.71552 6.28506 1.39979 6.58145 1.3067C7.34564 1.06668 8.15827 0.9375 9 0.9375C13.4528 0.9375 17.0625 4.5472 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.5472 17.0625 0.9375 13.4528 0.9375 9C0.9375 6.74472 1.86423 4.70487 3.35623 3.24224C3.57807 3.02477 3.93421 3.02831 4.15168 3.25015C4.36916 3.47199 4.36562 3.82813 4.14377 4.04561C2.85872 5.30536 2.0625 7.05919 2.0625 9C2.0625 12.8315 5.16852 15.9375 9 15.9375C12.8315 15.9375 15.9375 12.8315 15.9375 9C15.9375 5.16852 12.8315 2.0625 9 2.0625Z"
          fill="#5E718D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.60225 9.39775C8.49676 9.29226 8.4375 9.14918 8.4375 9V3.75C8.4375 3.43934 8.68934 3.1875 9 3.1875C9.31066 3.1875 9.5625 3.43934 9.5625 3.75V8.4375H14.25C14.5607 8.4375 14.8125 8.68934 14.8125 9C14.8125 9.31066 14.5607 9.5625 14.25 9.5625H9C8.85082 9.5625 8.70774 9.50324 8.60225 9.39775Z"
          fill="#5E718D"
        />
      </svg>
    </>
  );
}
